export const environment = {
  production: true,
  envName: "uat",
  applicationName: "Inmar.Healthcare.Recon",
  applicationApplinkFeature: "ReconUI",
  rootUrl: "https://uat-web-recon.healthcare.inmar.com",
  healthcareTopBar:
    "https://qa-web-auth.healthcare.inmar.com/Scripts/healthcare-topbar-v2.js",
  auth0: {
    domain: "ut-login.healthcare.inmar.com",
    clientId: "2EwvYPFIulULlZOlzW9UmpSvtu2XOE4b",
    refreshToken: true,
    scope: "openid profile email",
  },
  reconApiRoot: {
    url: "https://uat-api-recon.healthcare.inmar.com/v1.0",
    audience: "https://uat-api-recon.healthcare.inmar.com",
  },
  authZApiRoot: {
    url: "https://qa-api-authz.healthcare.inmar.com/v1.0",
    audience: "https://qa-api-authz.healthcare.inmar.com",
  },
  rebrandStartDate: "10-25-2019",
  globalFilterRefreshInterval: 60000,
  appInsights: {
    instrumentationKey: "",
  },
  googleAnalytics: {
    key: "",
  },
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts